/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AffiliatedGroupListItem } from '../../models/affiliated-group-list-item';

export interface ListAffiliatedGroups$Params {
}

export function listAffiliatedGroups(http: HttpClient, rootUrl: string, params?: ListAffiliatedGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AffiliatedGroupListItem>>> {
  const rb = new RequestBuilder(rootUrl, listAffiliatedGroups.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AffiliatedGroupListItem>>;
    })
  );
}

listAffiliatedGroups.PATH = '/rest/admin/affiliated-group';
